import { createContext } from 'react'
import { ToastType } from '@app/components/blocks/toast/Toast'

export type ToastModel = {
  id: string
  message: string
  type: ToastType
  title?: string
  hideAfterSeconds?: number
}

export type ToastContextType = {
  showToast: (
    type: ToastType,
    message: string,
    hideAfterSeconds?: number,
    title?: string,
  ) => void
  showSuccessToast: (
    message: string,
    hideAfterSeconds?: number,
    title?: string,
  ) => void
  showFailToast: (message?: string, hideAfterSeconds?: number) => void
}

export const ToastContext = createContext<ToastContextType>({
  showToast: () => {},
  showSuccessToast: () => {},
  showFailToast: () => {},
})
